import { Broker, BrokerAutoScalingGroupInstance, CodeDeployment } from '@amzn/amazonmq-opsconsole-client';
import {
    Box,
    KeyValuePairs,
    SpaceBetween,
    Spinner,
    StatusIndicator,
} from '@amzn/awsui-components-react';
import React from 'react';
import CodeDeployments from './CodeDeployments';
import { StatusIndicatorColor } from '../../../../types';

export interface Props {
    instance: BrokerAutoScalingGroupInstance;
    loading: boolean;
    deployments: CodeDeployment[];
    broker: Broker;
    getStatusColor: (state: string) => StatusIndicatorColor;
}

export const InstanceDetails: React.FC<Props> = ({
    instance,
    deployments,
    loading,
    broker,
    getStatusColor,
}) => (
    <SpaceBetween direction='vertical' size='s'>
        <Box variant="h4" textAlign={"left"}>{instance.instanceId}</Box>
        <KeyValuePairs
            columns={1}
            items={[
                {
                    label: 'Type',
                    value: instance.instanceType || '-'
                },
                {
                    label: (
                        <>
                            Lifecycle State {loading && <Spinner />}
                        </>
                    ),
                    value: (
                        <StatusIndicator type={getStatusColor(instance.lifecycleState)}>
                            {instance.lifecycleState}
                        </StatusIndicator>
                    )
                },
                {
                    label: 'Health Status',
                    value: instance.healthStatus || '-'
                },
                {
                    label: (
                        <>
                            Deployments {loading && <Spinner />}
                        </>
                    ),
                    value: (
                        <CodeDeployments instanceId={instance.instanceId} deployments={deployments} broker={broker} />
                    )
                }
            ]}
        />
    </SpaceBetween>
);

export default InstanceDetails;